module.exports = __webpack_public_path__ + "static/img/Inspection1.afc1353a.png";